import { IDagKvantitet } from "~app/common/models/dagkvantitet";
import { CommandBase } from "~app/common/services/cqs/commandManager";

export class SetLeveransradKvantitetCommand extends CommandBase {
    kundorderradId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetLeveransradKvantitetCommand) => void) {
        super("SetLeveransradKvantitetCommand");
        init(this);
    }
}
